import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import ElasticService from "src/services/elasticService";

import { FilterBadge } from "@shared/CustomBadge";
import { PrimaryButton } from "@shared/CustomButton";
import { UncontrolledTextField } from "@shared/form/TextField";
import { Modal } from "@shared/Modal/Modal";

type Props = {
    value: string | undefined;
    onChange: (value: string | undefined) => void;
};

export const ExactVersionHeader = ({ value, onChange }: Props) => {
    const { t } = useTranslation(["common", "modals"]);
    const location = useLocation();
    const [open, setOpen] = React.useState(false);
    const [draft, setDraft] = React.useState("");

    const title = t("common:label.version");

    const handleOpen = () => {
        setDraft(value ?? "");
        setOpen(true);
        ElasticService.createTransaction("tableFilter", { page: location.pathname, filterType: title });
    };

    const handleSave = () => {
        onChange(draft.trim() || undefined);
        setOpen(false);
    };

    return (
        <React.Fragment>
            <FilterBadge badgeContent={value ? 1 : 0} onClick={handleOpen} />
            <Modal
                open={open}
                title={title}
                description={t("modals:filterDialog.exactVersionHint")}
                onClose={() => setOpen(false)}
                endButton={<PrimaryButton onClick={handleSave}>{t("common:button.save")}</PrimaryButton>}
            >
                <UncontrolledTextField
                    autoFocus
                    fullWidth
                    value={draft}
                    placeholder="15.2.0"
                    onChange={(e) => setDraft(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            handleSave();
                        }
                    }}
                    slotProps={{ htmlInput: { "aria-label": title } }}
                />
            </Modal>
        </React.Fragment>
    );
};
